exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-1ba025c6] .sc-chip-select-chip{-webkit-transition:.3s;transition:.3s}", ""]);

// exports
